<template lang="">
    <span>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-tabs :key="isSmallerScreen" :position="isSmallerScreen ? 'top' : 'left'" :value="active_step"
                    class="tabs-shadow-none" id="profile-tabs">

                    <vs-tab :label="!isSmallerScreen ? 'Opportunity Pipeline' : ''" icon="icon-star" icon-pack="feather">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <customer-opportunities-aggregated-activity/>
                        </div>
                    </vs-tab>
                    <vs-tab :label="!isSmallerScreen ? 'Customer Contact Actions' : ''" icon="icon-phone-call" icon-pack="feather">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <customer-communication-aggregated-activity/>
                        </div>
                    </vs-tab>
                    <vs-tab :label="!isSmallerScreen ? 'Marketing Campaign ' : ''" icon="icon-mail" icon-pack="feather">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <customer-marketing-campaign-aggregated-activity/>
                        </div>
                    </vs-tab>
                    <vs-tab :label="!isSmallerScreen ? 'Value Added Moments (VAM) ' : ''" icon="icon-clock" icon-pack="feather">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <ValueAddedMomentsAggregatedActivity/>
                        </div>
                    </vs-tab>

                </vs-tabs>
            </div>
        </div>
    </span>
</template>
<script>
import CustomerOpportunitiesAggregatedActivity from './components/CustomerOpportunitiesAggregatedActivity.vue';
import CustomerCommunicationAggregatedActivity from './components/CustomerCommunicationAggregatedActivity.vue';
import CustomerMarketingCampaignAggregatedActivity from './components/CustomerMarketingCampaignAggregatedActivity.vue';
import ValueAddedMomentsAggregatedActivity from './components/ValueAddedMomentsAggregatedActivity.vue';

export default {
    name: 'CrmAggregatedActivityHome',
    data() {
        return {
            active_step: this.$route.query.step ? this.$route.query.step : '0'
        }
    },
    components: {
        CustomerOpportunitiesAggregatedActivity,
        CustomerCommunicationAggregatedActivity,
        CustomerMarketingCampaignAggregatedActivity,
        ValueAddedMomentsAggregatedActivity
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        }
    },
}
</script>
<style lang="scss">
#profile-tabs {
    .vs-tabs--content {
        padding: 0;
    }
}
</style>